<template>
  <div class="card">
    <div class="card-body">
      <div style="position:relative;">
        <h2>Tests</h2>
        <a href="/trials/create" class="btn btn-primary"
          style="position: absolute;right: 0;top: 0;"
        >
          <i class="fa fa-plus"></i> Create New Test
        </a>
      </div>
      <p><a href="/trials/report"><i class="fa fa-chart-bar"></i> Show Report</a></p>
      <trials-table-filter
        v-model="filter"
      />
      <div class="table-responsive">
        <table class="table table-striped" style="margin-top: 1rem;">
          <thead>
            <tr>
              <th style="width: 50px;"></th>
              <th scope="col" @click="sort('country')">
                Country
                <i class="fa" v-show="sortProp === 'country'"
                  :class="sortProp === 'country' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
                />
              </th>
              <th scope="col" @click="sort('distributor')">
                Distributor
                <i class="fa" v-show="sortProp === 'distributor'"
                  :class="sortProp === 'distributor' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
                />
              </th>
              <th scope="col" @click="sort('keyAccount')">
                Key Account
                <i class="fa" v-show="sortProp === 'keyAccount'"
                  :class="sortProp === 'keyAccount' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
                />
              </th>
              <th scope="col" @click="sort('start_date')">
                Start
                <i class="fa" v-show="sortProp === 'start_date'"
                  :class="sortProp === 'start_date' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
                />
              </th>
              <th scope="col" @click="sort('test_period')">
                Months
                <i class="fa" v-show="sortProp === 'test_period'"
                  :class="sortProp === 'test_period' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
                />
              </th>
              <th scope="col" @click="sort('stores')">
                Stores
                <i class="fa" v-show="sortProp === 'stores'"
                  :class="sortProp === 'stores' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
                />
              </th>
              <th scope="col" @click="sort('equipment')">
                Equipments
                <i class="fa" v-show="sortProp === 'equipment'"
                  :class="sortProp === 'equipment' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
                />
              </th>
              <th scope="col" @click="sort('bla1')"
              class="nowrap text-right">4' <i class="fa fa-fire"></i>
              <i class="fa" v-show="sortProp === 'bla1'"
                :class="sortProp === 'bla1' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
              />
            </th>
              <th scope="col" @click="sort('bla2')"
              class="nowrap text-right">8' <i class="fa fa-fire"></i>
              <i class="fa" v-show="sortProp === 'bla2'"
                :class="sortProp === 'bla2' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
              />
            </th>
              <th scope="col" @click="sort('user')">
                BManager
                <i class="fa" v-show="sortProp === 'user'"
                  :class="sortProp === 'user' && sortDir === 1 ? 'fa-sort-up' : 'fa-sort-down'"
                />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="trial in sortedTrials" :trial="trial"
              is="Trial"
              :key="trial.id"
              @deleteTrial="deleteTrial"
              @showGalleryModal="showGalleryModal"
              @showDistributorModal="showDistributorModal"
            >
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <gallery-modal v-if="trialToShow"
      :trial="trialToShow"
    />
    <distributor-modal v-if="distributorToShow"
      :distributor="distributorToShow"
    />
  </div>
</template>

<script>
  export default {
    props: ['initTrials'],
    data() {
      return {
        trials: this.initTrials,
        trialToShow: null,
        sortProp:'country',
        sortDir: 1,
        filter: 'running',
        isAdmin: window.isAdmin,
        distributorToShow: null,
      }
    },
    methods: {
      deleteTrial(trial) {
        if (window.confirm(`Do you really want to delete this test?`)) {
          window.axios.delete(`/trials/${trial.id}`).then(({data}) => {
            window.notification.success(`The test has been deleted`, 'Success!')
            const index = this.trials.findIndex(eTrial => eTrial.id === trial.id)
            this.trials.splice(index, 1)
          })
        }
      },
      showGalleryModal(trial) {
        window.axios(`trials/${trial.id}/communication_documents`).then(({data}) => {
          this.trialToShow = data
          this.$nextTick(() => $('#gallyerModal').modal('show'))
        })
      },
      sort(prop) {
        this.sortDir = this.sortDir * -1
        this.sortProp = prop
      },
      showDistributorModal(distributor) {
        this.distributorToShow = distributor
        this.$nextTick(() => $('#distributorModal').modal('show'))
      },
    },
    computed: {
      sortedTrials() {
        return this.trials.sort((a,b) => {
          let modifier = this.sortDir;

          if (this.sortProp === 'country') {
            a = a.country.name ? a.country.name.toLowerCase() : a.country.name
            b = b.country.name ? b.country.name.toLowerCase() : b.country.name
          } else if (this.sortProp === 'keyAccount') {
            a = a.key_account.name ? a.key_account.name.toLowerCase() : a.key_account.name
            b = b.key_account.name ? b.key_account.name.toLowerCase() : b.key_account.name
          } else if (this.sortProp === 'equipment') {
            a = a.formattedEquipmentsName ? a.formattedEquipmentsName.toLowerCase() : a.formattedEquipmentsName
            b = b.formattedEquipmentsName ? b.formattedEquipmentsName.toLowerCase() : b.formattedEquipmentsName
          } else if (this.sortProp === 'user') {
            a = a.user.name ? a.user.name.toLowerCase() : a.user.name
            b = b.user.name ? b.user.name.toLowerCase() : b.user.name
          } else if (this.sortProp === 'distributor') {
            a = a.distributor.company_name ? a.distributor.company_name.toLowerCase() : a.distributor.company_name
            b = b.distributor.company_name ? b.distributor.company_name.toLowerCase() : b.distributor.company_name
          } else {
            a = isNaN(a[this.sortProp]) || a[this.sortProp] === null ? a[this.sortProp] : +a[this.sortProp]
            b = isNaN(b[this.sortProp]) || b[this.sortProp] === null ? b[this.sortProp] : +b[this.sortProp]
          }

          if(a === null) return 1
          if(b === null) return -1
          if(a === b) return 0
          return a < b ? -1 * modifier : modifier

        }).filter(trial => {
          if (this.filter === 'running') {
            return ! trial.rolled_out_at && ! trial.archived_at
          } else if (this.filter === 'rolled_out') {
            return trial.rolled_out_at && ! trial.archived_at
          } else {
            return trial.archived_at
          }
        });
      },
    },
    mounted() {
      $(document).on('hide.bs.modal', '#gallyerModal', () => this.trialToShow = null)
    },
  }
</script>

<style lang="scss">
  .last-month-row {
    background-color: lighten(#C3040D, 54%) !important;
  }
  .archived-row {
    background-color: lighten(#FFB700, 40%) !important;
  }
</style>



// WEBPACK FOOTER //
// resources/js/components/trials/TrialsIndex.vue